import {NgModule} from '@angular/core';
import {SharedModule} from "../../shared.module";
import {ProductSelectionModule} from "../product-selection/product-selection.module";
import {ProductResultsCardModule} from "../product/results/product-results-card.module";
import {SurveyResultsComponent} from "./survey-results.component";

@NgModule({
    imports: [SharedModule, ProductResultsCardModule, ProductSelectionModule],
    declarations: [SurveyResultsComponent],
    exports: [SurveyResultsComponent]
})
export class SurveyResultsModule {}
